import React from 'react'
import { Accordion, AccordionSummary, Box, Skeleton, useTheme } from '@mui/material'
import { type ReportInsightsLoadingSection } from '../reportInsightsLoading'
import { getSurveySectionCardSx, surveySectionListSx, surveySectionSummaryLayoutSx } from './surveySectionCardStyles'

interface ReportInsightsSkeletonProps {
  sections: ReportInsightsLoadingSection[]
}

const ReportInsightsSkeleton: React.FC<ReportInsightsSkeletonProps> = ({ sections }) => {
  const theme = useTheme()

  return (
    <Box
      aria-label="Loading report sections"
      sx={surveySectionListSx}
    >
      {sections.map((section) => (
        <Accordion
          elevation={0}
          expanded={false}
          key={section.id}
          data-testid="report-insights-skeleton-card"
          sx={getSurveySectionCardSx(theme)}
        >
          <AccordionSummary
            aria-hidden="true"
            expandIcon={
              <Skeleton
                animation="wave"
                variant="circular"
                width={24}
                height={24}
              />
            }
          >
            <Box sx={surveySectionSummaryLayoutSx}>
              <Box display="flex" flexDirection="column" gap={1.25} minWidth={0} flex={1}>
                <Skeleton
                  animation="wave"
                  variant="text"
                  width="38%"
                  height={40}
                  sx={{ transform: 'none' }}
                />
                {section.showInstructorLine && (
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width="24%"
                    height={26}
                    sx={{ transform: 'none' }}
                  />
                )}
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  width={114}
                  height={32}
                  sx={{ borderRadius: 16 }}
                />
              </Box>
            </Box>
          </AccordionSummary>
        </Accordion>
      ))}
    </Box>
  )
}

export default ReportInsightsSkeleton
